/*
DEPRECATED
This class allows the MakeModelMenu elm app to dynamically interact with an ad
that was not rendered immediately.
Its use is considered deprecated, along with elm. If you're looking to
extend this, please instead consider using something else
*/
export class MakeModelMenuAd extends HTMLElement {
  connectedCallback () {
    if (!this.isConnected) return;

    this.setupAd(document.querySelector('carwow-make-model-menu-ad'), this)
  }

  setupAd (adNode) {
    // Pushing to the intermediate array just in case the googletag is not loaded yet.
    window.carwowGoogleTag.push(() => {
      window.googletag.cmd.push(() => {
        // be careful of the lexical value of `this` if you move this.
        this.innerHTML = adNode.innerHTML
        this.setDisplayOnChildGoogleAdElements()
        this.displayAdSlotLater(adNode)
      })
    })
  }

  // There's a chance that .google-ad elements will be initialized with display:none
  // This is because we might want to run A/B tests on multiple ads.
  // GOTCHA: be careful not to accidentally target script elements.
  setDisplayOnChildGoogleAdElements () {
    const googleAdElement = Array.from(this.childNodes).find((node) =>
      node.classList?.contains('google-ad')
    );

    if (googleAdElement) {
      googleAdElement.display = 'block'
    }
  }

  displayAdSlotLater (adNode) {
    const adSlot = this.findAdSlot(adNode)

    // We push the slot to the carwowGoogleAdSlots array whose contents
    // are passed to pubads.refresh() inside the initializer function
    // once the user has interacted with the cookie consent UI.
    window.carwowGoogleAdSlots.push(adSlot)
  }

  findAdSlot (adNode) {
    return window.googletag
    .pubads()
    .getSlots()
    .find((slot) => slot.getSlotElementId() === adNode.querySelector('.google-ad').id)
  }
}
